import styled from 'styled-components';
import { BaseCell } from 'core/table/BaseCell';

// https://cloudcannon.com/deconstructions/2014/11/15/facebook-content-placeholder-deconstruction.html
const AnimatedGradient = styled.div`
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(90deg, #f4f4f4 69.54%, #eae9ea 98.05%);
  background-size: 800px 104px;
  border-radius: 100px;
  height: 14px;
`;

const createLoadingCell = (useBaseCell /*: boolean */) => () => {
  const Cell = <AnimatedGradient data-test="loading-cell" />;

  if (useBaseCell) {
    return <BaseCell>{Cell}</BaseCell>;
  }
  return Cell;
};

export const LoadingCell = createLoadingCell(true);
export const CleanLoadingCell = createLoadingCell(false);
